<span id="createReverseAuditWizard_step2">
  <h1>Step 2: Chain Codes / In Program</h1>
  <div class="titlebar-div" >Chain Codes</div>

  <div class="containingRow">
    <span class="buttonclass">
      <fieldset ngl-radio-group>
        <ngl-radio-option label="Include" class="radio">
          <input
            ngl
            [checked]="true"
            [(ngModel)]="includeChainCodes"
            value="include"
            type="radio" />
        </ngl-radio-option>
        <ngl-radio-option label="Exclude" class="radio">
          <input
            ngl
            [(ngModel)]="includeChainCodes"
            value="exclude"
            type="radio" />
        </ngl-radio-option>
      </fieldset>
    </span>
    <span class="buttonclass">
      <button
        class="k-button cvt-tertiary"
        (click)="addAllChainCodes()">All</button>
      <button
        class="k-button cvt-tertiary"
        (click)="clearAllChainCodes()">Clear</button>
      <input
        type="text"
        class="newChainCodeTextInput"
        [(ngModel)]="newChainCode">
      <span
        class="cvt-tertiary rvrs-new-audit cvt-icon-addCircleFilled plus"
        (click)="addChainCode($event)"></span>
    </span>
  </div>
  <div id="chainCodeListTextInputContainer" class="containingRow">
    <span
      class="cvt-tertiary chainCodeSpan"
      *ngFor="let chainCode of visibleChainCodeList">
      <span
        class="k-icon k-delete k-i-x"
        aria-label="Remove"
        title="Remove"
        (click)="removeChainCodeFromVisibleList(chainCode)">
      </span>
      {{ chainCode }}
    </span>
  </div>
  <div class="titlebar-div" >Properties In Program</div>

  <div class="containingRow">
    <kendo-grid
      [data]="gridView"
      class="propertyGrid"
      [sort]="state.sort"
      [sortable]="true"
      [pageSize]="state.take"
      [pageable]="{buttonCount: 5}"
      [skip]="state.skip"
      [kendoGridSelectBy]="'PropertyName'"
      (dataStateChange)="dataStateChange($event)"
      [scrollable]="'scrollable'">
      <kendo-grid-column [width]="50">
        <ng-template kendoGridHeaderTemplate  let-column >
          <ngl-checkbox>
            <input
              ngl
              type="checkbox"
              [(ngModel)]="allPropertiesChecked"
              (ngModelChange)="allPropertiesClicked($event)" />
          </ngl-checkbox>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-column>
          <ngl-checkbox>
            <input
              ngl
              type="checkbox"
              [(ngModel)]="dataItem.IsChecked" />
          </ngl-checkbox>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyNameLowerCase" title="Property" [width]="190">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
          </ng-template>
          <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
           <span >{{dataItem.PropertyName}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AmadeusChainCode" title="Amadeus Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="ApolloChainCode" title="Apollo Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="GalileoChainCode" title="Galileo Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="SabreChainCode" title="Sabre Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="WorldspanChainCode" title="Worldspan Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyAddressLowerCase" title="Address" [width]="250">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
              <span >{{dataItem.PropertyAddress}}</span>
             </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyCityLowerCase" title="City" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
              <span >{{dataItem.PropertyCity}}</span>
             </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyStateProvince" title="State/Province" [width]="200">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyPostalCode" title="Postal Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyCountryLowerCase" title="Country" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column >
              <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
              <span >{{dataItem.PropertyCountry}}</span>
             </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</span>
